import React from 'react';

import { Pressable, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

type AgeAssuranceBlockedScreenProps = {
  onRetry: () => void;
};

export const AgeAssuranceBlockedScreen = ({ onRetry }: AgeAssuranceBlockedScreenProps) => {
  const insets = useSafeAreaInsets();
  const retryLabel = t('ageAssuranceTryAgain', 'Try Again');

  return (
    <View
      accessibilityViewIsModal
      importantForAccessibility="yes"
      style={[
        styles.container,
        { paddingTop: insets.top + spacing.$6, paddingBottom: insets.bottom + spacing.$6 },
      ]}
      testID="age-assurance-blocked"
    >
      <View style={styles.content}>
        <Typography accessibilityRole="header" bold textAlign="center" variant="headerOne">
          {t('ageAssuranceBlockedTitle', "Sorry, you can't use the BK® app right now")}
        </Typography>
        <Typography textAlign="center">
          {t(
            'ageAssuranceBlockedBody',
            'The Burger King app is only available to guests who meet our age requirements.'
          )}
        </Typography>
        <Typography textAlign="center">
          {t(
            'ageAssuranceBlockedHelp',
            'Think this is a mistake? Update your age information with your app store provider and try again.'
          )}
        </Typography>
        <Pressable
          accessibilityLabel={retryLabel}
          accessibilityRole="button"
          onPress={onRetry}
          style={({ pressed }) => [styles.button, pressed && styles.buttonPressed]}
          testID="age-assurance-try-again"
        >
          <Typography bold color={primitive.$white}>
            {retryLabel}
          </Typography>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: primitive.$mayoEggWhite,
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: spacing.$6,
  },
  content: {
    alignItems: 'center',
    gap: spacing.$5,
    maxWidth: 480,
    width: '100%',
  },
  button: {
    alignItems: 'center',
    backgroundColor: primitive.$fieryRed,
    borderCurve: 'continuous',
    borderRadius: 9999,
    justifyContent: 'center',
    minHeight: spacing.$12,
    paddingHorizontal: spacing.$6,
    width: '100%',
  },
  buttonPressed: {
    backgroundColor: primitive.$fieryRedPressed,
  },
});
